'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InputField = require('./InputField');

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputAffix = function InputAffix(props) {
    var prefix = props.prefix,
        postfix = props.postfix;

    return _react2.default.createElement("div", { className: "luna-affix" }, prefix && _react2.default.createElement("span", { className: "luna-affix__label" }, prefix), _react2.default.createElement(_InputField2.default, Object.assign({}, props)), postfix && _react2.default.createElement("span", { className: "luna-affix__label" }, postfix));
};
InputAffix.propTypes = {
    prefix: _propTypes2.default.string.isRequired,
    postfix: _propTypes2.default.string.isRequired
};
exports.default = InputAffix;
//# sourceMappingURL=InputAffix.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Input/InputAffix.js